<app-field-renderer
  [form]="form"
  [roles]="roleColors"
  [isRoleEditable]="isRoleEditable"
  [isRequiredEditable]="false"
  [boundsRef]="boundsRef"
  [inBounds]="inBounds"
  [zoomScale]="zoomScale"
  [offsetRect]="offsetRect"
  [role2ColorMapping]="role2ColorMapping"
  resizableEdges="w,e"
  (afterMove)="onMove()"
  (afterResize)="onResize()"
  (remove)="onRemove($event)"
  (roleChange)="onRoleChange($event)"
>
  <ng-container class="title">
    <i class="far fa-calendar mr-2"></i> <ng-container i18n>Sign Date</ng-container>
  </ng-container>
  <ng-container class="label">
    <i class="cs-icon cs-icon-calendar-check"></i>
    <span *ngIf="role">{{ role }}</span> {{ label || defaultLabel }}
  </ng-container>
</app-field-renderer>
